package com.schoolconnect.app.feature.documents

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.Image
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.platform.LocalDensity
import com.schoolconnect.app.designsystem.AppDialogActionStyle
import com.schoolconnect.app.designsystem.AppDialogErrorMessage
import com.schoolconnect.app.designsystem.AppDialogFooter
import com.schoolconnect.app.designsystem.AppDialogFooterAction
import com.schoolconnect.app.designsystem.AppDialogHeader
import com.schoolconnect.app.designsystem.AppDialogScaffold
import com.schoolconnect.app.designsystem.AppDialogTextField
import com.schoolconnect.app.designsystem.AppOutlinedButton
import com.schoolconnect.app.designsystem.AppDialogFieldHeight
import com.schoolconnect.app.designsystem.AppDropdownMenu
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.AppCard
import com.schoolconnect.app.designsystem.AppText
import com.schoolconnect.app.designsystem.AppSurface
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.designsystem.AppOrangeText
import com.schoolconnect.app.designsystem.AppOrangeSoft
import com.schoolconnect.app.designsystem.AppInputBorder
import com.schoolconnect.app.designsystem.list.AdminListFooter
import com.schoolconnect.app.designsystem.list.AdminListPageScaffold
import com.schoolconnect.app.designsystem.list.AdminListPrimaryActionButton
import com.schoolconnect.app.designsystem.list.AdminListSearchField
import com.schoolconnect.app.designsystem.list.AdminListSummaryCard
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListTableShimmer
import com.schoolconnect.app.designsystem.list.AdminListTableBody
import com.schoolconnect.app.designsystem.list.AdminListTableBodyText
import com.schoolconnect.app.designsystem.list.AdminListTableCard
import com.schoolconnect.app.designsystem.list.AdminListSortColumn
import com.schoolconnect.app.designsystem.list.AdminListSortHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListToolbar
import com.schoolconnect.app.designsystem.list.AdminListToolbarButton
import com.schoolconnect.app.designsystem.list.AdminListTypography
import com.schoolconnect.app.designsystem.list.onViewDoubleClick
import com.schoolconnect.app.feature.common.pageFooterText
import com.schoolconnect.app.feature.common.pageWindow
import com.schoolconnect.app.feature.common.ShellTopRightActions
import com.schoolconnect.app.feature.common.shellAvatarInitials
import com.schoolconnect.app.feature.common.shellRoleLabel
import com.schoolconnect.app.feature.common.shellRoleSubtitle
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.chevron_down
import ischoolconnect.sharedui.generated.resources.cloud_upload
import ischoolconnect.sharedui.generated.resources.close_x
import ischoolconnect.sharedui.generated.resources.document
import ischoolconnect.sharedui.generated.resources.download
import ischoolconnect.sharedui.generated.resources.eye
import ischoolconnect.sharedui.generated.resources.pencil
import ischoolconnect.sharedui.generated.resources.search
import ischoolconnect.sharedui.generated.resources.refresh_cw
import org.jetbrains.compose.resources.painterResource
import io.github.vinceglb.filekit.compose.rememberFilePickerLauncher
import io.github.vinceglb.filekit.core.PickerType
import io.github.vinceglb.filekit.core.PlatformFile
import kotlinx.coroutines.launch
import com.schoolconnect.app.util.decodeImageBitmap
import com.schoolconnect.app.repository.files.FileUploadRepository

private val LibraryBackground = AppBackground
private val LibraryBorder = AppBorder
private const val MaxDocumentBytes = 50L * 1024L * 1024L

@Composable
internal fun DocumentLibraryScreen(
    uiState: DocumentLibraryUiState,
    onQueryChanged: (String) -> Unit,
    onCategoryChanged: (String) -> Unit,
    onApplicableToChanged: (String) -> Unit,
    onClearFilters: () -> Unit = { onQueryChanged(""); onCategoryChanged("All Categories"); onApplicableToChanged("All Users") },
    onPageChanged: (Int) -> Unit,
    onPageSizeChanged: (Int) -> Unit,
    onSortChanged: (DocumentLibrarySortField) -> Unit,
    onCreateDocument: (DocumentLibraryDraft, () -> Unit) -> Unit,
    onUpdateDocument: (String, String, String, String, String, List<String>, () -> Unit) -> Unit = { _, _, _, _, _, _, _ -> },
    canEdit: Boolean = true,
    classOptions: List<DocumentLibraryClassOption>,
    isLoadingClassOptions: Boolean,
    classOptionsError: String,
    categoryOptions: List<DocumentLibraryLookupOption> = emptyList(),
    audienceOptions: List<DocumentLibraryLookupOption> = emptyList(),
    isLoadingLookupOptions: Boolean = false,
    lookupOptionsError: String = "",
    schoolLabel: String,
    academicYearLabel: String,
    headerActions: @Composable RowScope.() -> Unit,
    onLoadDocumentDetails: (String, (DocumentLibraryRow) -> Unit) -> Unit = { _, _ -> },
    onDownload: (DocumentLibraryRow) -> Unit = {},
    onBack: () -> Unit = {}
) {
    val query = uiState.query
    val category = uiState.category.ifBlank { "All Categories" }
    val audience = uiState.applicableTo.ifBlank { "All Users" }
    val categoryFilterOptions = listOf("All Categories") + categoryOptions.map { it.label }
    val audienceFilterOptions = listOf("All Users") + audienceOptions.map { it.label }
    val lookupsReady = !isLoadingLookupOptions && lookupOptionsError.isBlank() && categoryOptions.isNotEmpty() && audienceOptions.isNotEmpty()
    val pageIndex = uiState.pageIndex
    val pageSize = uiState.pageSize
    var rowsMenuExpanded by remember { mutableStateOf(false) }
    var dialog by remember { mutableStateOf<DocumentLibraryDialog?>(null) }

    val rows = remember(uiState.documents) { uiState.documents.map { it.toDocumentLibraryRow() } }
    val window = pageWindow(pageIndex, pageSize, uiState.totalCount)

    AdminListPageScaffold(
        title = "Manage Document Library",
        subtitle = "Upload and manage school documents for parents and teachers.",
        headerActions = headerActions,
        backgroundColor = LibraryBackground,
        maxContentWidth = 1240.dp,
        summaryCards = {
            LibrarySummaryCard("Total Documents", uiState.totalCount.toString(), "All documents", Res.drawable.cloud_upload, AppPrimary, AppPrimarySoft)
            LibrarySummaryCard("Policies", uiState.metrics?.policies?.toString() ?: "—", "Published policies", Res.drawable.document, AppSuccess, AppSuccessSoft)
            LibrarySummaryCard("Forms & Guidelines", uiState.metrics?.formsGuidelines?.toString() ?: "—", "Forms and guidelines", Res.drawable.document, Color(0xFF303C88), Color(0xFFF0F1F8))
            LibrarySummaryCard("Recently Updated", uiState.metrics?.recentlyUpdated?.toString() ?: "—", "Updated in last 30 days", Res.drawable.eye, AppOrangeText, AppOrangeSoft)
        },
        toolbar = {
            AppCard(Modifier.fillMaxWidth(), containerColor = AppSurface) {
                Column(Modifier.fillMaxWidth().padding(16.dp)) {
                    AdminListToolbar(
                        searchQuery = query,
                        onSearchQueryChanged = onQueryChanged,
                        searchPlaceholder = "Search by Document ID or Title",
                        searchWidth = 370.dp,
                        height = 44.dp,
                        surfaceColor = AppSurface,
                        borderColor = AppBorder,
                        searchIconTint = AppMuted,
                        searchTextColor = AppNavy,
                        searchCursorColor = AppPrimary,
                        inlineContent = {
                            LibraryDropdown("Category", category, categoryFilterOptions, Modifier.width(220.dp), onCategoryChanged, enabled = lookupsReady)
                            LibraryDropdown("Applicable To", audience, audienceFilterOptions, Modifier.width(220.dp), onApplicableToChanged, enabled = lookupsReady)
                        }
                    ) {
                        AdminListToolbarButton(label = "Clear", icon = painterResource(Res.drawable.refresh_cw), onClick = onClearFilters, width = 116.dp, height = 44.dp, surfaceColor = AppSurface, borderColor = AppInputBorder, contentColor = AppPrimary)
                    }
                }
            }
        },
        table = { modifier ->
            AdminListTableCard(
                modifier = modifier,
                minContentWidth = 980.dp,
                header = {
                    AdminListSortHeaderRow(
                        columns = listOf(
                            AdminListSortColumn("Document ID", 1.05f, uiState.sortField == DocumentLibrarySortField.DOCUMENT_ID, uiState.sortAscending) { onSortChanged(DocumentLibrarySortField.DOCUMENT_ID) },
                            AdminListSortColumn("Document Title", 1.7f, uiState.sortField == DocumentLibrarySortField.TITLE, uiState.sortAscending) { onSortChanged(DocumentLibrarySortField.TITLE) },
                            AdminListSortColumn("Category", 1.05f, uiState.sortField == DocumentLibrarySortField.CATEGORY, uiState.sortAscending) { onSortChanged(DocumentLibrarySortField.CATEGORY) },
                            AdminListSortColumn("Applicable To", 1.15f, uiState.sortField == DocumentLibrarySortField.APPLICABLE_TO, uiState.sortAscending) { onSortChanged(DocumentLibrarySortField.APPLICABLE_TO) },
                            AdminListSortColumn("File Type", .8f, uiState.sortField == DocumentLibrarySortField.FILE_TYPE, uiState.sortAscending) { onSortChanged(DocumentLibrarySortField.FILE_TYPE) },
                            AdminListSortColumn("Updated On", 1f, uiState.sortField == DocumentLibrarySortField.UPDATED_ON, uiState.sortAscending) { onSortChanged(DocumentLibrarySortField.UPDATED_ON) }
                        ),
                        actionsLabel = "Actions",
                        actionsWeight = .7f,
                        actionsAlignment = Alignment.Center,
                        horizontalPadding = 18.dp
                    )
                },
                body = {
                    if (uiState.isLoading) {
                        AdminListTableShimmer(
                            columns = listOf(
                                AdminListHeaderColumn("Document ID", 1.05f),
                                AdminListHeaderColumn("Document Title", 1.7f),
                                AdminListHeaderColumn("Category", 1.05f),
                                AdminListHeaderColumn("Applicable To", 1.15f),
                                AdminListHeaderColumn("File Type", .8f),
                                AdminListHeaderColumn("Updated On", 1f),
                                AdminListHeaderColumn("Actions", .7f, alignCenter = true)
                            ),
                            horizontalPadding = 18.dp,
                            modifier = Modifier.fillMaxWidth().height(300.dp)
                        )
                    } else if (rows.isEmpty()) {
                        Box(Modifier.fillMaxWidth().height(220.dp), contentAlignment = Alignment.Center) {
                            Text("No documents match your filters", color = AppMuted, fontWeight = FontWeight.SemiBold)
                        }
                    } else {
                        AdminListTableBody(items = rows, key = { it.id }, modifier = Modifier.fillMaxWidth()) { row ->
                            Column(Modifier.fillMaxWidth()) {
                                DocumentRow(
                                    row,
                                    onView = {
                                        dialog = DocumentLibraryDialog.View(row)
                                        onLoadDocumentDetails(row.documentId.ifBlank { row.id }) { details ->
                                            if ((dialog as? DocumentLibraryDialog.View)?.row?.id == row.id) {
                                                dialog = DocumentLibraryDialog.View(details)
                                            }
                                        }
                                    },
                                    onEdit = {
                                        dialog = DocumentLibraryDialog.Edit(row)
                                        onLoadDocumentDetails(row.documentId.ifBlank { row.id }) { details ->
                                            if ((dialog as? DocumentLibraryDialog.Edit)?.row?.id == row.id) {
                                                dialog = DocumentLibraryDialog.Edit(details)
                                            }
                                        }
                                    },
                                    showEdit = canEdit
                                )
                                if (row != rows.last()) {
                                    Box(
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .height(1.dp)
                                            .background(AppBorder)
                                    )
                                }
                            }
                        }
                    }
                },
                footer = {
                    AdminListFooter(
                        pageText = pageFooterText(window, "documents"),
                        pageIndex = window.pageIndex,
                        pageCount = window.pageCount,
                        onPageChanged = onPageChanged,
                        pageSize = pageSize,
                        rowsPerPageExpanded = rowsMenuExpanded,
                        onRowsPerPageToggle = { rowsMenuExpanded = !rowsMenuExpanded },
                        onRowsPerPageDismiss = { rowsMenuExpanded = false },
                        onPageSizeChanged = onPageSizeChanged
                    )
                }
            )
        },
        bottomAction = {
            AdminListPrimaryActionButton("Upload Document", painterResource(Res.drawable.cloud_upload), { dialog = DocumentLibraryDialog.Add }, modifier = Modifier.width(238.dp))
        }
    )

    dialog?.let { activeDialog ->
        DocumentDialog(
            dialog = activeDialog,
            onDismiss = { dialog = null },
            onSave = { row -> dialog = null },
            onCreateDocument = onCreateDocument,
            onUpdateDocument = onUpdateDocument,
            onDownload = onDownload,
            classOptions = classOptions,
            isLoadingClassOptions = isLoadingClassOptions,
            classOptionsError = classOptionsError,
            categoryOptions = categoryOptions.map { it.label },
            audienceOptions = audienceOptions.map { it.label },
            lookupOptionsReady = lookupsReady,
            isSaving = uiState.isSaving,
            errorMessage = uiState.errorMessage
        )
    }
}

@Composable
internal fun ParentDocumentLibraryScreen(
    uiState: ParentDocumentLibraryUiState,
    onQueryChanged: (String) -> Unit,
    onCategoryChanged: (String) -> Unit,
    onPageChanged: (Int) -> Unit,
    onPageSizeChanged: (Int) -> Unit,
    onSortChanged: (DocumentLibrarySortField) -> Unit,
    onLoadDocumentDetails: (String, (DocumentLibraryRow) -> Unit) -> Unit,
    onDownload: (String) -> Unit,
    shellRoleCode: String,
    onChangeRole: () -> Unit,
    onLogout: () -> Unit,
    onRetryLookupOptions: () -> Unit = {},
    categoryOptions: List<DocumentLibraryLookupOption> = emptyList(),
    isLoadingLookupOptions: Boolean = false,
    lookupOptionsError: String = ""
) {
    var rowsMenuExpanded by remember { mutableStateOf(false) }
    var dialog by remember { mutableStateOf<DocumentLibraryDialog?>(null) }
    var profileExpanded by remember { mutableStateOf(false) }
    val rows = remember(uiState.documents) { uiState.documents.map { it.toDocumentLibraryRow() } }
    val window = pageWindow(uiState.pageIndex, uiState.pageSize, uiState.totalCount)
    val categoryFilterOptions = listOf("All Categories") + categoryOptions.map { it.label }
    val lookupsReady = !isLoadingLookupOptions && lookupOptionsError.isBlank() && categoryOptions.isNotEmpty()

    AdminListPageScaffold(
        title = "Document Library",
        subtitle = "View school policies, guidelines, forms and other documents.",
        headerActions = {
            ShellTopRightActions(
                roleLabel = shellRoleLabel(shellRoleCode),
                roleSubtitle = shellRoleSubtitle(shellRoleCode),
                initials = shellAvatarInitials(shellRoleLabel(shellRoleCode)),
                expanded = profileExpanded,
                onExpandedChange = { profileExpanded = it },
                onChangeRole = onChangeRole,
                onLogout = onLogout
            )
        },
        backgroundColor = LibraryBackground,
        maxContentWidth = 1240.dp,
        summaryCards = {},
        toolbar = {
            AppCard(Modifier.fillMaxWidth(), containerColor = AppSurface) {
                Column(Modifier.fillMaxWidth().padding(16.dp)) {
                    AdminListToolbar(
                        searchQuery = uiState.query,
                        onSearchQueryChanged = onQueryChanged,
                        searchPlaceholder = "Search by Document ID, title, or file name",
                        searchWidth = 370.dp,
                        height = 44.dp,
                        compactBreakpoint = 600.dp,
                        surfaceColor = AppSurface,
                        borderColor = AppBorder,
                        searchIconTint = AppMuted,
                        searchTextColor = AppNavy,
                        searchCursorColor = AppPrimary,
                        inlineContent = {
                            LibraryDropdown("Category", uiState.category.ifBlank { "All Categories" }, categoryFilterOptions, Modifier.width(220.dp), onCategoryChanged, enabled = lookupsReady)
                        }
                    ) {
                        AdminListToolbarButton(label = "Clear", icon = painterResource(Res.drawable.refresh_cw), onClick = { onQueryChanged(""); onCategoryChanged("All Categories") }, width = 116.dp, height = 44.dp, surfaceColor = AppSurface, borderColor = AppInputBorder, contentColor = AppPrimary)
                    }
                    if (lookupOptionsError.isNotBlank()) {
                        Row(
                            modifier = Modifier.fillMaxWidth().padding(top = 8.dp),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(12.dp)
                        ) {
                            Text(
                                text = lookupOptionsError,
                                color = AppDanger,
                                fontSize = 12.sp,
                                modifier = Modifier.weight(1f)
                            )
                            AdminListToolbarButton(
                                label = "Retry categories",
                                icon = painterResource(Res.drawable.refresh_cw),
                                onClick = onRetryLookupOptions,
                                width = 180.dp,
                                height = 40.dp,
                                surfaceColor = AppSurface,
                                borderColor = AppInputBorder,
                                contentColor = AppPrimary
                            )
                        }
                    }
                }
            }
        },
        table = { modifier ->
            AdminListTableCard(
                modifier = modifier,
                minContentWidth = 900.dp,
                header = {
                    AdminListSortHeaderRow(
                        listOf(
                            AdminListSortColumn("Document ID", 1.05f, uiState.sortField == DocumentLibrarySortField.DOCUMENT_ID, uiState.sortAscending) { onSortChanged(DocumentLibrarySortField.DOCUMENT_ID) },
                            AdminListSortColumn("Document Title", 1.9f, uiState.sortField == DocumentLibrarySortField.TITLE, uiState.sortAscending) { onSortChanged(DocumentLibrarySortField.TITLE) },
                            AdminListSortColumn("Category", 1.25f, uiState.sortField == DocumentLibrarySortField.CATEGORY, uiState.sortAscending) { onSortChanged(DocumentLibrarySortField.CATEGORY) },
                            AdminListSortColumn("File Type", .9f, uiState.sortField == DocumentLibrarySortField.FILE_TYPE, uiState.sortAscending) { onSortChanged(DocumentLibrarySortField.FILE_TYPE) },
                            AdminListSortColumn("Updated On", 1.1f, uiState.sortField == DocumentLibrarySortField.UPDATED_ON, uiState.sortAscending) { onSortChanged(DocumentLibrarySortField.UPDATED_ON) }
                        ),
                        actionsLabel = "Actions",
                        actionsWeight = .65f,
                        actionsAlignment = Alignment.Center,
                        horizontalPadding = 18.dp
                    )
                },
                body = {
                    if (uiState.isLoading) {
                        AdminListTableShimmer(columns = listOf(
                            AdminListHeaderColumn("Document ID", 1.05f),
                            AdminListHeaderColumn("Document Title", 1.9f),
                            AdminListHeaderColumn("Category", 1.25f),
                            AdminListHeaderColumn("File Type", .9f),
                            AdminListHeaderColumn("Updated On", 1.1f),
                            AdminListHeaderColumn("Actions", .65f, alignCenter = true)
                        ), rowCount = uiState.pageSize)
                    } else if (uiState.errorMessage.isNotBlank()) {
                        Box(Modifier.fillMaxWidth().height(220.dp), contentAlignment = Alignment.Center) { AppDialogErrorMessage(uiState.errorMessage) }
                    } else if (rows.isEmpty()) {
                        Box(Modifier.fillMaxWidth().height(220.dp), contentAlignment = Alignment.Center) {
                            Text("No documents match your filters", color = AppMuted, fontWeight = FontWeight.SemiBold)
                        }
                    } else {
                        AdminListTableBody(items = rows, key = { it.id }, modifier = Modifier.fillMaxWidth()) { row ->
                            Column(Modifier.fillMaxWidth()) {
                                ParentDocumentRow(
                                    row = row,
                                    onView = {
                                        dialog = DocumentLibraryDialog.View(row)
                                        onLoadDocumentDetails(row.documentId.ifBlank { row.id }) { details ->
                                            if ((dialog as? DocumentLibraryDialog.View)?.row?.id == row.id) {
                                                dialog = DocumentLibraryDialog.View(details)
                                            }
                                        }
                                    },
                                    onDownload = { onDownload(row.documentId.ifBlank { row.id }) }
                                )
                                if (row != rows.last()) {
                                    Box(
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .height(1.dp)
                                            .background(AppBorder)
                                    )
                                }
                            }
                        }
                    }
                },
                footer = {
                    AdminListFooter(
                        pageText = pageFooterText(window, "documents"),
                        pageIndex = window.pageIndex,
                        pageCount = window.pageCount,
                        onPageChanged = onPageChanged,
                        pageSize = uiState.pageSize,
                        rowsPerPageExpanded = rowsMenuExpanded,
                        onRowsPerPageToggle = { rowsMenuExpanded = !rowsMenuExpanded },
                        onRowsPerPageDismiss = { rowsMenuExpanded = false },
                        onPageSizeChanged = onPageSizeChanged
                    )
                }
            )
        },
        bottomAction = {}
    )

    dialog?.let { activeDialog ->
        DocumentDialog(dialog = activeDialog, onDismiss = { dialog = null }, onSave = {}, onCreateDocument = { _, _ -> }, onDownload = { row -> onDownload(row.documentId.ifBlank { row.id }) }, isSaving = false, errorMessage = uiState.downloadError)
    }
}

@Composable
private fun RowScope.LibrarySummaryCard(title: String, value: String, subtitle: String, icon: org.jetbrains.compose.resources.DrawableResource, accent: Color, accentBg: Color) {
    AdminListSummaryCard(
        title,
        value,
        subtitle,
        painterResource(icon),
        accent,
        accentBg,
        AppMuted,
        modifier = Modifier.weight(1f),
        contentPadding = PaddingValues(horizontal = 16.dp, vertical = 18.dp),
        iconSize = 56.dp,
        iconGlyphSize = 28.dp,
        contentSpacing = 12.dp,
        cardHeight = 144.dp
    )
}

@Composable
private fun LibraryDropdown(label: String, value: String, options: List<String>, modifier: Modifier, onSelected: (String) -> Unit, enabled: Boolean = true) {
    var expanded by remember { mutableStateOf(false) }
    var anchorWidth by remember { mutableStateOf(0.dp) }
    val density = LocalDensity.current
    Column(modifier, verticalArrangement = Arrangement.spacedBy(6.dp)) {
        Text(label, color = AppNavy, style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.SemiBold))
        Box(
            Modifier
                .fillMaxWidth()
                .height(AppDialogFieldHeight)
                .onGloballyPositioned { anchorWidth = with(density) { it.size.width.toDp() } }
                .border(1.dp, LibraryBorder, RoundedCornerShape(8.dp))
                .clickable(enabled = enabled) { expanded = true },
            contentAlignment = Alignment.CenterStart
        ) {
            Row(Modifier.fillMaxWidth().padding(horizontal = 14.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                Text(value, color = AppNavy, style = MaterialTheme.typography.bodyMedium, maxLines = 1, overflow = TextOverflow.Ellipsis)
                Icon(painterResource(Res.drawable.chevron_down), null, tint = if (enabled) AppNavy else AppMuted, modifier = Modifier.size(18.dp))
            }
            AppDropdownMenu(
                expanded = expanded,
                onDismissRequest = { expanded = false },
                width = anchorWidth.takeIf { it > 0.dp },
                containerColor = Color.White,
                border = BorderStroke(1.dp, LibraryBorder)
            ) {
                options.forEach { option -> DropdownMenuItem(text = { Text(option, color = AppNavy, style = MaterialTheme.typography.bodyMedium) }, onClick = { expanded = false; onSelected(option) }) }
            }
        }
    }
}

@Composable
private fun DocumentHeaderRow() {
    Row(Modifier.fillMaxWidth().padding(horizontal = 18.dp, vertical = 14.dp), verticalAlignment = Alignment.CenterVertically) {
        HeaderCell("Document ID", 1.05f); HeaderCell("Document Title", 1.7f); HeaderCell("Category", 1.05f); HeaderCell("Applicable To", 1.15f); HeaderCell("File Type", .8f); HeaderCell("Updated On", 1f); HeaderCell("Actions", .7f, true)
    }
}

@Composable
private fun ParentDocumentHeaderRow() {
    Row(Modifier.fillMaxWidth().padding(horizontal = 18.dp, vertical = 14.dp), verticalAlignment = Alignment.CenterVertically) {
        HeaderCell("Document ID", 1.05f)
        HeaderCell("Document Title", 1.9f)
        HeaderCell("Category", 1.25f)
        HeaderCell("File Type", .9f)
        HeaderCell("Updated On", 1.1f)
        HeaderCell("Actions", .65f, true)
    }
}

@Composable
private fun RowScope.HeaderCell(label: String, weight: Float, alignEnd: Boolean = false) {
    Text(label, modifier = Modifier.weight(weight), color = AppNavy, style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.SemiBold), maxLines = 1, overflow = TextOverflow.Ellipsis)
}

@Composable
private fun DocumentRow(row: DocumentLibraryRow, onView: () -> Unit, onEdit: () -> Unit, showEdit: Boolean = true) {
    Row(Modifier.fillMaxWidth().onViewDoubleClick(onView).padding(horizontal = 18.dp, vertical = 15.dp), verticalAlignment = Alignment.CenterVertically) {
        TableCell(row.id, 1.05f, AppPrimary); TableCell(row.title, 1.7f); TableCell(row.category, 1.05f); TableCell(row.applicableTo, 1.15f); TableCell(row.fileType, .8f); TableCell(row.updatedOn, 1f)
            Row(Modifier.weight(.7f), horizontalArrangement = Arrangement.spacedBy(2.dp, Alignment.CenterHorizontally), verticalAlignment = Alignment.CenterVertically) {
                IconButton(onClick = onView, modifier = Modifier.size(32.dp)) {
                    Icon(painterResource(Res.drawable.eye), "View ${row.id}", tint = AppNavy, modifier = Modifier.size(16.dp))
                }
                if (showEdit) IconButton(onClick = onEdit, modifier = Modifier.size(32.dp)) {
                    Icon(painterResource(Res.drawable.pencil), "Edit ${row.id}", tint = AppNavy, modifier = Modifier.size(16.dp))
                }
            }
    }
}

@Composable
private fun ParentDocumentRow(row: DocumentLibraryRow, onView: () -> Unit, onDownload: () -> Unit) {
    Row(
        Modifier
            .fillMaxWidth()
            .combinedClickable(onClick = {}, onDoubleClick = onView)
            .padding(horizontal = 18.dp, vertical = 15.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        TableCell(row.id, 1.05f, AppPrimary)
        TableCell(row.title, 1.9f)
        TableCell(row.category, 1.25f)
        TableCell(row.fileType, .9f)
        TableCell(row.updatedOn, 1.1f)
        Box(Modifier.weight(.65f).height(32.dp), contentAlignment = Alignment.Center) {
            Row(horizontalArrangement = Arrangement.spacedBy(2.dp), verticalAlignment = Alignment.CenterVertically) {
                IconButton(onClick = onView, modifier = Modifier.size(32.dp)) {
                    Icon(painterResource(Res.drawable.eye), "View ${row.id}", tint = AppNavy, modifier = Modifier.size(16.dp))
                }
                IconButton(onClick = onDownload, modifier = Modifier.size(32.dp)) {
                    Icon(painterResource(Res.drawable.download), "Download ${row.id}", tint = AppNavy, modifier = Modifier.size(16.dp))
                }
            }
        }
    }
}

@Composable
private fun RowScope.TableCell(value: String, weight: Float, color: Color = AppNavy) {
    AdminListTableBodyText(value, Modifier.weight(weight), color = color, fontWeight = FontWeight.Medium, maxLines = 1)
}

private sealed interface DocumentLibraryDialog {
    data object Add : DocumentLibraryDialog
    data class Edit(val row: DocumentLibraryRow) : DocumentLibraryDialog
    data class View(val row: DocumentLibraryRow) : DocumentLibraryDialog
}

@Composable
private fun DocumentDialog(
    dialog: DocumentLibraryDialog,
    onDismiss: () -> Unit,
    onSave: (DocumentLibraryRow) -> Unit,
    onCreateDocument: (DocumentLibraryDraft, () -> Unit) -> Unit,
    onUpdateDocument: (String, String, String, String, String, List<String>, () -> Unit) -> Unit = { _, _, _, _, _, _, _ -> },
    onDownload: (DocumentLibraryRow) -> Unit = {},
    isSaving: Boolean = false,
    errorMessage: String = ""
    ,classOptions: List<DocumentLibraryClassOption> = emptyList()
    ,isLoadingClassOptions: Boolean = false
    ,classOptionsError: String = ""
    ,categoryOptions: List<String> = emptyList()
    ,audienceOptions: List<String> = emptyList()
    ,lookupOptionsReady: Boolean = false
) {
    val existing = (dialog as? DocumentLibraryDialog.Edit)?.row ?: (dialog as? DocumentLibraryDialog.View)?.row
    val readOnly = dialog is DocumentLibraryDialog.View
    var title by remember(existing?.id, dialog::class) { mutableStateOf(existing?.title.orEmpty()) }
    var category by remember(existing?.id, dialog::class) { mutableStateOf(existing?.category.orEmpty()) }
    var audience by remember(existing?.id, dialog::class) { mutableStateOf(existing?.applicableTo ?: "All Users") }
    var classTargetIds by remember(existing?.id, dialog::class) { mutableStateOf<List<String>>(emptyList()) }
    var description by remember(existing?.id, dialog::class) { mutableStateOf(existing?.description.orEmpty()) }
    var selectedFile by remember(existing?.id, dialog::class) { mutableStateOf<PlatformFile?>(null) }
    var selectedPreviewBytes by remember(existing?.id, dialog::class) { mutableStateOf<ByteArray?>(null) }
    var existingPreviewBytes by remember(existing?.id, dialog::class) { mutableStateOf<ByteArray?>(null) }
    var fileError by remember(existing?.id, dialog::class) { mutableStateOf("") }
    val coroutineScope = rememberCoroutineScope()
    LaunchedEffect(existing?.id, existing?.fileId, existing?.fileName, readOnly) {
        existingPreviewBytes = null
        val file = existing ?: return@LaunchedEffect
        if (!readOnly || file.fileId.isBlank()) return@LaunchedEffect
        val metadata = FileUploadRepository.getMetadata(file.fileId).getOrNull()
        val mimeType = metadata?.detectedMimeType ?: metadata?.declaredMimeType ?: documentContentType(file.fileName)
        if (!mimeType.startsWith("image/", ignoreCase = true)) return@LaunchedEffect
        val url = FileUploadRepository.getDownloadUrl(file.fileId).getOrNull()?.url.orEmpty()
        if (url.isNotBlank()) existingPreviewBytes = FileUploadRepository.downloadBytes(url).getOrNull()
    }
    val filePicker = rememberFilePickerLauncher(
        type = PickerType.File(listOf("pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "odt", "ods", "csv", "txt", "jpg", "jpeg", "png", "webp", "gif")),
        title = "Select Document File"
    ) { file ->
        selectedFile = file
        fileError = ""
        selectedPreviewBytes = null
        file?.let { selected ->
            val extension = selected.name.substringAfterLast('.', "").lowercase()
            if (extension in setOf("jpg", "jpeg", "png", "webp", "gif")) {
                coroutineScope.launch { selectedPreviewBytes = runCatching { selected.readBytes() }.getOrNull() }
            }
        }
    }
    val dialogTitle = when (dialog) { DocumentLibraryDialog.Add -> "Add Document"; is DocumentLibraryDialog.Edit -> "Edit Document"; is DocumentLibraryDialog.View -> "View Document" }
    val subtitle = when (dialog) { DocumentLibraryDialog.Add -> "Add a document to the school library"; is DocumentLibraryDialog.Edit -> "Update document details or replace the existing file"; is DocumentLibraryDialog.View -> "View document details and download the file" }

    AppDialogScaffold(
        onDismiss = { if (!isSaving) onDismiss() },
        size = com.schoolconnect.app.designsystem.AppDialogSize.Wide,
        dialogWidthOverride = 760.dp,
        isLoading = isSaving,
        loadingTitle = "Uploading document"
    ) {
        AppDialogHeader(dialogTitle, subtitle, onDismiss, icon = Res.drawable.document, titleSuffix = existing?.id, iconContentDescription = "Document")
        Column(Modifier.padding(horizontal = 28.dp), verticalArrangement = Arrangement.spacedBy(14.dp)) {
            if (readOnly && existing != null) {
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                Metadata("Created By", existing.createdBy); Metadata("Created On", existing.createdOn)
                }
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                Metadata("Last Updated By", existing.updatedBy); Metadata("Last Updated On", existing.updatedOn)
                }
            }
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(20.dp)) {
                LabeledDialogField("Document Title", title, { title = it }, if (readOnly) title else "Enter document title", readOnly, Modifier.weight(1f))
                LibraryDialogDropdown("Category", category.ifBlank { "Select category" }, categoryOptions, readOnly || !lookupOptionsReady, Modifier.weight(1f)) { category = it }
            }
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(20.dp)) {
                LibraryDialogDropdown("Applicable To", audience, audienceOptions, readOnly || !lookupOptionsReady, Modifier.weight(1f)) {
                    audience = it
                    if (!it.equals("Classes", ignoreCase = true) && !it.equals("Selected Classes", ignoreCase = true)) classTargetIds = emptyList()
                }
                val classesAudienceSelected = audience.equals("Classes", ignoreCase = true) || audience.equals("Selected Classes", ignoreCase = true)
                if (classesAudienceSelected) {
                    val selectedClasses = classOptions.filter { it.id in classTargetIds }
                    val classLabel = when {
                        selectedClasses.isNotEmpty() -> "${selectedClasses.size} class${if (selectedClasses.size == 1) "" else "es"} selected"
                        isLoadingClassOptions -> "Loading classes..."
                        classOptions.isEmpty() && classOptionsError.isNotBlank() -> "Unable to load classes"
                        else -> "Select classes"
                    }
                    LibraryMultiSelectDropdown("Classes & Sections", classLabel, classOptions, classTargetIds, readOnly || isLoadingClassOptions || classOptions.isEmpty(), Modifier.weight(1f)) { id ->
                        classTargetIds = if (id in classTargetIds) classTargetIds - id else classTargetIds + id
                    }
                } else {
                    LabeledDialogField("Classes & Sections", "Not Applicable", {}, "Available for selected classes", true, Modifier.weight(1f))
                }
            }
            if ((audience.equals("Classes", ignoreCase = true) || audience.equals("Selected Classes", ignoreCase = true)) && classOptionsError.isNotBlank()) Text(classOptionsError, color = AppDanger, style = MaterialTheme.typography.bodySmall)
            LabeledDialogField(
                "Description",
                if (readOnly && description == "—") "No description provided" else description,
                { description = it },
                if (readOnly) description else "Enter a brief description (optional)",
                readOnly,
                Modifier.fillMaxWidth()
            )
            FileSummary(
                existing = existing,
                selectedFile = selectedFile,
                selectedPreviewBytes = selectedPreviewBytes ?: existingPreviewBytes,
                readOnly = readOnly,
                onBrowse = { filePicker.launch() },
                onClearSelection = { selectedFile = null; selectedPreviewBytes = null; fileError = "" }
            )
            if (fileError.isNotBlank()) Text(fileError, color = AppDanger, style = MaterialTheme.typography.bodySmall)
            if (errorMessage.isNotBlank() && !readOnly) AppDialogErrorMessage(errorMessage)
        }
        Spacer(Modifier.height(12.dp))
        if (readOnly) {
            AppDialogFooter(listOf(AppDialogFooterAction("Close", onDismiss, width = 130.dp), AppDialogFooterAction("Download", { existing?.let(onDownload) }, AppDialogActionStyle.Primary, width = 150.dp)))
        } else {
            AppDialogFooter(listOf(AppDialogFooterAction("Cancel", onDismiss, enabled = !isSaving, width = 130.dp), AppDialogFooterAction(if (isSaving) "Uploading..." else "Save & Publish", {
                if (dialog is DocumentLibraryDialog.Add) {
                    val file = selectedFile
                    if (file == null) {
                        fileError = "Select a document file before saving."
                    } else {
                        coroutineScope.launch {
                            if ((file.getSize() ?: 0L) > MaxDocumentBytes) {
                                fileError = "File must be 50 MB or smaller."
                                return@launch
                            }
                            val bytes = runCatching { file.readBytes() }.getOrNull()
                            if (bytes == null || bytes.isEmpty()) fileError = "Unable to read the selected file."
                        else if ((audience.equals("Classes", ignoreCase = true) || audience.equals("Selected Classes", ignoreCase = true)) && classTargetIds.isEmpty()) {
                            fileError = "Select at least one class before saving."
                        } else onCreateDocument(DocumentLibraryDraft(title.trim(), description.trim(), category, audience, file.name, documentContentType(file.name), bytes, classTargetIds)) { onDismiss() }
                        }
                    }
                } else onUpdateDocument(existing?.documentId?.ifBlank { existing.id }.orEmpty(), title, description, category, audience, classTargetIds) { onDismiss() }
            }, AppDialogActionStyle.Primary, enabled = title.isNotBlank() && category.isNotBlank() && !isSaving, width = 190.dp)))
        }
    }
}

@Composable
private fun LabeledDialogField(label: String, value: String, onValueChange: (String) -> Unit, placeholder: String, readOnly: Boolean, modifier: Modifier) {
    Column(modifier, verticalArrangement = Arrangement.spacedBy(6.dp)) {
        Text(label, color = AppNavy, style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.SemiBold))
        AppDialogTextField(value, onValueChange, placeholder = placeholder, readOnly = readOnly)
    }
}

@Composable
private fun LibraryDialogDropdown(label: String, value: String, options: List<String>, readOnly: Boolean, modifier: Modifier, onSelected: (String) -> Unit) {
    var expanded by remember { mutableStateOf(false) }
    var anchorWidth by remember { mutableStateOf(0.dp) }
    val density = LocalDensity.current
    Column(modifier, verticalArrangement = Arrangement.spacedBy(6.dp)) {
        Text(label, color = AppNavy, style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.SemiBold))
        Box(
            Modifier
                .fillMaxWidth()
                .height(AppDialogFieldHeight)
                .onGloballyPositioned { anchorWidth = with(density) { it.size.width.toDp() } }
                .border(1.dp, LibraryBorder, RoundedCornerShape(8.dp))
                .clickable(enabled = !readOnly) { expanded = true },
            contentAlignment = Alignment.CenterStart
        ) {
            Row(Modifier.fillMaxWidth().padding(horizontal = 14.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) { Text(value, color = if (value.startsWith("Select")) AppMuted else AppNavy, style = MaterialTheme.typography.bodyMedium); Icon(painterResource(Res.drawable.chevron_down), null, tint = AppNavy, modifier = Modifier.size(18.dp)) }
            AppDropdownMenu(expanded, { expanded = false }, width = anchorWidth.takeIf { it > 0.dp }, containerColor = AppSurface, border = BorderStroke(1.dp, LibraryBorder)) { options.forEach { option -> DropdownMenuItem(text = { Text(option, color = AppNavy, style = MaterialTheme.typography.bodyMedium) }, onClick = { expanded = false; onSelected(option) }) } }
        }
    }
}

@Composable
private fun LibraryMultiSelectDropdown(
    label: String,
    value: String,
    options: List<DocumentLibraryClassOption>,
    selectedIds: List<String>,
    readOnly: Boolean,
    modifier: Modifier,
    onToggle: (String) -> Unit
) {
    var expanded by remember { mutableStateOf(false) }
    var anchorWidth by remember { mutableStateOf(0.dp) }
    val density = LocalDensity.current
    Column(modifier, verticalArrangement = Arrangement.spacedBy(6.dp)) {
        Text(label, color = AppNavy, style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.SemiBold))
        Box(
            Modifier
                .fillMaxWidth()
                .height(AppDialogFieldHeight)
                .onGloballyPositioned { anchorWidth = with(density) { it.size.width.toDp() } }
                .border(1.dp, LibraryBorder, RoundedCornerShape(8.dp))
                .clickable(enabled = !readOnly) { expanded = true },
            contentAlignment = Alignment.CenterStart
        ) {
            Row(Modifier.fillMaxWidth().padding(horizontal = 14.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                Text(value, color = if (value.startsWith("Select") || value.startsWith("Loading") || value.startsWith("Unable")) AppMuted else AppNavy, style = MaterialTheme.typography.bodyMedium, maxLines = 1, overflow = TextOverflow.Ellipsis)
                Icon(painterResource(Res.drawable.chevron_down), null, tint = AppNavy, modifier = Modifier.size(18.dp))
            }
            AppDropdownMenu(expanded, { expanded = false }, width = anchorWidth.takeIf { it > 0.dp }, containerColor = Color.White, border = BorderStroke(1.dp, LibraryBorder)) {
                Column(Modifier.heightIn(max = 320.dp).verticalScroll(rememberScrollState())) {
                    options.forEach { option ->
                        DropdownMenuItem(
                            text = { Text(if (option.id in selectedIds) "✓ ${option.label}" else option.label, color = AppNavy, style = MaterialTheme.typography.bodyMedium) },
                            onClick = { onToggle(option.id) }
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun Metadata(label: String, value: String) {
    Row(horizontalArrangement = Arrangement.spacedBy(14.dp)) {
        Text(label, color = AppMuted, style = MaterialTheme.typography.bodyMedium)
        Text(value.takeUnless { it == "—" }.orEmpty().ifBlank { "Not available" }, color = AppNavy, style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.SemiBold))
    }
}

@Composable
private fun FileSummary(
    existing: DocumentLibraryRow?,
    selectedFile: PlatformFile?,
    selectedPreviewBytes: ByteArray?,
    readOnly: Boolean,
    onBrowse: () -> Unit = {},
    onClearSelection: () -> Unit = {}
) {
    Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
        Text(if (readOnly) "Document File" else if (existing == null) "Upload File *" else "Current File", color = AppNavy, style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.SemiBold))
        if (!readOnly) {
            Row(
                Modifier.fillMaxWidth().border(1.dp, LibraryBorder, RoundedCornerShape(8.dp)).background(Color.White, RoundedCornerShape(8.dp)).padding(10.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                AppOutlinedButton(
                    onClick = onBrowse,
                    modifier = Modifier.width(170.dp).height(44.dp),
                    contentPadding = PaddingValues(horizontal = 12.dp),
                    colors = ButtonDefaults.outlinedButtonColors(contentColor = AppPrimary),
                    shape = RoundedCornerShape(8.dp)
                ) {
                    Icon(painterResource(Res.drawable.cloud_upload), null, tint = AppPrimary, modifier = Modifier.size(18.dp))
                    Spacer(Modifier.width(8.dp))
                    Text(if (existing == null) "Upload Files" else "Replace File", color = AppPrimary, fontWeight = FontWeight.SemiBold)
                }
                Spacer(Modifier.width(14.dp))
                Text(selectedFile?.name ?: existing?.fileName?.takeUnless { it == "—" } ?: "No files selected", color = AppMuted, fontSize = 13.sp, maxLines = 1, overflow = TextOverflow.Ellipsis)
            }
            selectedFile?.let { file ->
                DocumentAttachmentChip(file, selectedPreviewBytes, Modifier.fillMaxWidth(), onClearSelection)
            }
        } else {
            Box(Modifier.fillMaxWidth().height(72.dp).border(1.dp, LibraryBorder, RoundedCornerShape(8.dp)).background(Color.White, RoundedCornerShape(8.dp)).padding(horizontal = 18.dp), contentAlignment = Alignment.CenterStart) {
                Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                    val preview = selectedPreviewBytes?.let(::decodeImageBitmap)
                    if (preview != null) {
                        Image(preview, existing?.fileName ?: "Document preview", Modifier.size(52.dp), contentScale = androidx.compose.ui.layout.ContentScale.Crop)
                    } else {
                        Icon(painterResource(Res.drawable.document), null, tint = AppPrimary, modifier = Modifier.size(30.dp))
                    }
                    Spacer(Modifier.width(12.dp))
                    Column {
                        Text(existing?.fileName?.takeUnless { it == "—" } ?: "File name not available", color = AppNavy, style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.SemiBold), maxLines = 1, overflow = TextOverflow.Ellipsis)
                        Text(existing?.let { "${it.fileType} · ${it.fileSizeLabel.takeUnless { size -> size == "—" } ?: "Size unavailable"}" } ?: "File", color = AppMuted, style = MaterialTheme.typography.bodySmall)
                    }
                }
            }
        }
        Text("Supported formats: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, ODT, ODS, CSV, TXT, JPG, JPEG, PNG, WEBP, GIF (Maximum size: 50 MB)", color = AppMuted, fontSize = 12.sp)
    }
}

@Composable
private fun DocumentAttachmentChip(file: PlatformFile, previewBytes: ByteArray?, modifier: Modifier, onRemove: () -> Unit) {
    Row(
        modifier.height(72.dp).border(1.dp, LibraryBorder, RoundedCornerShape(8.dp)).background(Color.White, RoundedCornerShape(8.dp)).padding(horizontal = 10.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        val preview = previewBytes?.let(::decodeImageBitmap)
        if (preview != null) {
            Image(preview, file.name, Modifier.size(52.dp), contentScale = androidx.compose.ui.layout.ContentScale.Crop)
        } else {
            Box(Modifier.size(36.dp).background(Color(0xFFEAF0FF), RoundedCornerShape(6.dp)), contentAlignment = Alignment.Center) {
                Icon(painterResource(Res.drawable.document), null, tint = AppPrimary, modifier = Modifier.size(20.dp))
            }
        }
        Spacer(Modifier.width(8.dp))
        Column(Modifier.weight(1f)) {
            Text(file.name, color = AppNavy, fontSize = 12.sp, maxLines = 1, overflow = TextOverflow.Ellipsis)
            Text("${file.name.substringAfterLast('.', "FILE").uppercase()}  •  ${formatDocumentAttachmentSize(file.getSize())}", color = AppMuted, fontSize = 11.sp)
        }
        Icon(painterResource(Res.drawable.close_x), "Remove ${file.name}", tint = AppNavy, modifier = Modifier.size(18.dp).clickable(onClick = onRemove))
    }
}

private fun formatDocumentAttachmentSize(bytes: Long?): String = when {
    bytes == null || bytes <= 0L -> "File"
    bytes < 1024L -> "$bytes B"
    bytes < 1024L * 1024L -> "${bytes / 1024L} KB"
    else -> "${bytes / (1024L * 1024L)} MB"
}

private fun documentContentType(filename: String): String = when (filename.substringAfterLast('.', "").lowercase()) {
    "pdf" -> "application/pdf"
    "doc" -> "application/msword"
    "docx" -> "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    "xls" -> "application/vnd.ms-excel"
    "xlsx" -> "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    "ppt" -> "application/vnd.ms-powerpoint"
    "pptx" -> "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    "odt" -> "application/vnd.oasis.opendocument.text"
    "ods" -> "application/vnd.oasis.opendocument.spreadsheet"
    "csv" -> "text/csv"
    "txt" -> "text/plain"
    "jpg", "jpeg" -> "image/jpeg"
    "png" -> "image/png"
    "webp" -> "image/webp"
    "gif" -> "image/gif"
    else -> "application/octet-stream"
}
